/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { User } from '../../types';
import { ListUsersAction, ListUsersActionTypes, ListUsersFilter } from './types';

export interface ListUsersState {
  error?: Error;
  loading?: boolean;
  users: User[];
  filter?: ListUsersFilter;
  query: string;
  size: number;
  total: number;
  currentPage: number;
}

const size: number = 20;

export const initialListUsersState: ListUsersState = {
  users: [],
  filter: {},
  loading: true,
  query: '',
  size,
  total: 0,
  currentPage: 1,
};

export default function listUsersReducer(state = initialListUsersState, action: ListUsersAction) {
  switch (action.type) {
    case ListUsersActionTypes.LIST_USERS_REQUEST:
      const { query, filter, size, currentPage } = action.input;

      return update(state, {
        $unset: ['error'],
        loading: { $set: true },
        filter: { $set: filter },
        query: { $set: query },
        size: { $set: size },
        currentPage: { $set: currentPage },
      });

    case ListUsersActionTypes.LIST_USERS_SUCCESS:
      return update(state, {
        loading: { $set: false },
        users: { $set: action.users },
        total: { $set: action.total },
      });

    case ListUsersActionTypes.LIST_USERS_ERROR:
      return update(state, {
        error: { $set: action.error },
        loading: { $set: false },
      });

    case ListUsersActionTypes.RESET_ERROR:
      return update(state, { $unset: ['error'] });

    case ListUsersActionTypes.RESET_STATE:
      return initialListUsersState;

    default:
      return state;
  }
}
